/**
 * Feature key constants for per-session feature controls.
 */
export const FEATURE_KEYS = {
    LIVESTREAMING: 'livestreaming',
    SHARED_VIDEO: 'sharedvideo',
    SHARE_AUDIO: 'shareaudio',
    NOISE_SUPPRESSION: 'noisesuppression',
    WHITEBOARD: 'whiteboard'
};
/**
 * Conference metadata key used to sync feature controls across participants.
 */
export const FEATURE_CONTROLS_METADATA_KEY = 'featureControls';
